"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnonymousClient = useAnonymousClient;
const AnonymousClient_1 = require("@juvare/platform-sdk-js/AnonymousClient");
const react_1 = __importDefault(require("react"));
function useAnonymousClient(app, entity) {
    return react_1.default.useMemo(() => new AnonymousClient_1.AnonymousClient(app, entity), [app, entity]);
}
